export const getLangIdName = (names: { [x: string]: string }, currentLang: string | number, langIdData: { [x: string]: { [x: string]: string } }) => {
  let result = (names?.lang_id || names?.langId) || ''
  const langId = names['lang_id']
  if (langIdData[currentLang] && langIdData[currentLang][langId]) {
    result = langIdData[currentLang][langId]
  } else if (names[currentLang]) {
    result = names[currentLang]
  }
  return result
}